import React, { useContext } from 'react';
import { Link } from 'react-router-dom';

import { Grid, AppBar } from '@material-ui/core';

import Logo from '../../../assets/logo_jamii_2.svg';
import useStyles from './styles';
import { Context as ViewsContext } from '../../../context/ViewsContext';

const Navbar = ({
  leftContainerChildren,
  centerContainerChildren,
  rightContainerChildren,
}) => {
  const {
    navbarRoot,
    leftContainer,
    centerContainer,
    rightContainer,
    logoClass,
  } = useStyles();

  const { setView } = useContext(ViewsContext);

  return (
    <AppBar position="fixed" className={navbarRoot}>
      <Grid container>
        <Grid item container xs={4} className={leftContainer}>
          {leftContainerChildren}
        </Grid>
        <Grid item container xs={4} className={centerContainer}>
          {centerContainerChildren || (
            <Link to="/" onClick={() => setView(0)}>
              <img src={Logo} alt="jamii-logo" className={logoClass} />
            </Link>
          )}
        </Grid>
        <Grid item container xs={4} className={rightContainer}>
          {rightContainerChildren}
        </Grid>
      </Grid>
    </AppBar>
  );
};

export default Navbar;
